export default "__VITE_ASSET__749bf811__"